/*
 * Copyright © 2020-2026 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 *   原来这里渲染「今日龙虾 Claw」入口卡片(右上角浮卡)。
 *   2026-05-21 产品要求下线该入口,该组件目前为空壳,保留挂载点以备后续接入。
 *   如需恢复 Claw 入口,git 历史里取 ClawEntryCard + useIsAdmin + showClawEntry state。
 */
import React from 'react'

type BuildingSafetyEntryProps = {
  // 历史 prop;旧调用方仍可能传入,组件内当前不消费,保留签名兼容。
  onTrack?: (clickItem: string, restProperties?: Record<string, any>) => void
}

const BuildingSafetyEntry: React.FC<BuildingSafetyEntryProps> = () => null

export default BuildingSafetyEntry
